import { poulaillerJpg } from '../assets/images';

function Poulailler() {
    return (
        <div>
            <div
                className="hero h-[18rem] bg-cover bg-no-repeat"
                style={{
                    backgroundImage: `url(${poulaillerJpg})`,
                    backgroundPosition: "center",
                }}
            >   
                <div className="hero-overlay bg-opacity-60"></div>
                <div className="hero-content text-neutral-content text-center">
                    <h1 className="mb-5 text-5xl text-white font-bold">
                        Stratégies pour Maintenir la Santé des Animaux
                    </h1>
                </div>
            </div>
            <div className="px-6 lg:px-32 text-justify"> {/* Responsive padding */}
                <h1 className="text-4xl bg-black text-white p-4 text-center font-bold my-10">
                    Comment bien choisir
                </h1>
                <div className="text-gray-700 text-xl gap-8 leading-10 my-20">
                    <p>
                        L’indispensable pour votre élevage de poules, c’est un bon poulailler. Pour que vos poules se sentent bien et pour qu’elles soient productives, il est important de leur offrir un abri adapté. Pour les néophytes, il peut être difficile de faire le bon choix.
                    </p>

                    <h2 className="text-2xl font-semibold my-4">Choisir le meilleur emplacement</h2>
                    <p>
                        Avant de choisir votre poulailler, vous devez déterminer son emplacement. L’idéal est un espace abrité de l’humidité, du grand vent et d’un soleil plombant. Suivant son emplacement, vous pouvez opter pour un poulailler urbain, pour un modèle classique ou encore pour un modèle adossé à votre abri de jardinage.
                    </p>

                    <h2 className="text-2xl font-semibold my-4">Les dimensions</h2>
                    <p>
                        Pour assurer le bien-être de vos poules, vous devez leur offrir un espace vital suffisant. Le choix de votre poulailler dépend donc en premier lieu du nombre de poules que vous souhaitez élever. L’idéal est d’opter pour un poulailler mixte, offrant un espace douillet dans lequel les poules pourront faire leur nid et une volière, dans laquelle elles pourront aller et venir lorsqu’elles seront enfermées. Comptez 1m² pour 4 poules en intérieur, 1m² par poule dans l’enclos.
                    </p>

                    <h2 className="text-2xl font-semibold my-4">Les matériaux</h2>
                    <p>
                        Un cabanon de jardin métal ou bois : il s’agit avant tout d’une question d’esthétique. Mais en ce qui concerne votre poulailler, la question des matériaux est capitale. Il est important que vos poules soient préservées en cas de canicule comme de gelée. Le bois est le plus répandu : résistant, écologique et excellent isolant, il ne nécessite qu’un entretien minimal.
                    </p>

                    <h2 className="text-2xl font-semibold my-4">Les accessoires</h2>
                    <p>
                        Pondoirs et perchoirs sont parfois inclus dans le poulailler. Mais d’autres équipements sont à prévoir. L’abreuvoir et le distributeur de nourriture sont indispensables pour permettre à vos poules d’avoir accès à des denrées propres. Si vous choisissez un poulailler avec volière, gardez à l’esprit que ce n’est pas suffisant. Vos poules auront besoin de davantage d’espace. Il vous faudra donc prévoir aussi un enclos plus vaste, dans lequel elles pourront gambader. Enfin, si votre région est exposée à des hivers rudes, il est recommandé d’investir dans un chauffage.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Poulailler;
